export const CookieKey = {
  AccessToken: 'accessToken',
  RefreshToken: 'refreshToken',
  OrderToken: 'cartToken',
  TokenExpiration: 'tokenExpiration',
} as const;
